import {useMemo} from "react";
import {parseValidFileTypes} from "components/Shared/MDropzone/utility";

const useParseValidFileTypes = validFileTypes => {
  const {parsedValidFileTypes, accept} = useMemo(
    () => {
      const parsedValidFileTypes = parseValidFileTypes(validFileTypes);
      return {
        parsedValidFileTypes,
        accept: Array.isArray(parsedValidFileTypes)
          ? parsedValidFileTypes.join(", ")
          : parsedValidFileTypes
      };
    },
    [validFileTypes]
  );
  return {parsedValidFileTypes, accept};
};

export default useParseValidFileTypes;